const __WEBPACK_NAMESPACE_OBJECT__ = require("@adc/core-utils");